/**
 * Created by Carsten Bühler
 * User: CBuehler on 15.02.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';

import ChangeRecordListItem from './ChangeRecordListItem';

const JournalEntryChangeRecordRenderer = ({ message, entry }) => {
    return <ChangeRecordListItem item={message} userMeta={entry.userMeta}/>;
};

JournalEntryChangeRecordRenderer.propTypes = {
    message: PropTypes.object,
    entry: PropTypes.object
};

export default JournalEntryChangeRecordRenderer;




// WEBPACK FOOTER //
// ./js/components/JournalEntryChangeRecordRenderer.jsx